import { useNavigate } from "react-router-dom"
import { InformationIcon } from "../../images/Icons"
import '../../App.css'


export function InformationButton() {
    const navigate = useNavigate()
    return (
        <div className='iconButton' onClick={() => {
                navigate('/Information')
        }}>
            <InformationIcon/>
             </div>
    )
}